import * as pageStyles from "../../styles/internal-page/internal-page.module.scss";
import * as responsiveStyles from "../../styles/responsive.module.scss";

import ActionElement from "../shared/ActionElement";
import PolyLink from "../shared/PolyLink";
import React from "react";
import clsx from "clsx";
import {useTranslation} from "react-i18next";


const MarketingButton = ({
  actionElement,
  secondActionElement,
  knowMore,
  onclick,
  mobile,
}) => {

  const {t} = useTranslation();

  const getAriaLabelButtonAttribute = (actionElement) => {
    const msg = []
    if (actionElement?.icon ==='DOWNLOAD') {
      msg.push(t('marketing.button.action.download', {
        document: actionElement?.label,
    }))
    } else {
      msg.push(t('marketing.button.action.url'))
      if (actionElement?.new_window) {
        msg.push(t('marketing.button.action.new-window'))
      }
    }
    return msg.join(' ')
  }


  const getKnowMoreAriaLabel = (knowMore) => {
    return t('marketing.button.action.view', {
      document: knowMore
    })
  }

  if (!actionElement) {
    return <></>
  }

  const actionElementParse = (actionElement.related_contents) ? actionElement.related_contents[0].content[0] : actionElement;
  return (
    <ActionElement>
      <div className={clsx(pageStyles.marketingButtonWidth, {[responsiveStyles.smartphone]: mobile})}>
        {actionElementParse?.__typename ===
          "CmsPortalComponentWidgetActionElement" && (
          <div
            className={pageStyles.compsFlex}
            style={{flexBasis: knowMore || secondActionElement ? '50%' : '100%'}}
          >
            <button className={pageStyles.darkButton} tabIndex="0"
                aria-label={getAriaLabelButtonAttribute(actionElementParse)}
            >
              <PolyLink url={actionElementParse?.URL} target="_blank">
                <p className={pageStyles.labelButton}>
                  {actionElementParse?.label}
                </p>
              </PolyLink>
            </button>
          </div>
        )}
        {secondActionElement?.__typename ===
          "CmsPortalComponentWidgetActionElement" && (
          <div
            className={pageStyles.compsFlex}
            style={{flexBasis: "50%"}}
          >
            <button className={pageStyles.redButton} tabIndex="0"
              aria-label={getAriaLabelButtonAttribute(secondActionElement)}
            >
              <PolyLink url={secondActionElement?.URL} target="_blank">
                <p className={pageStyles.labelButton}>
                  {secondActionElement?.label}
                </p>
              </PolyLink>
            </button>
          </div>
        )}
        {knowMore && (
          <div
            style={{flexBasis:
              actionElementParse?.__typename ===
              "CmsPortalComponentWidgetActionElement"
                ? '50%'
                : '100%'
            }}
            className={pageStyles.compsFlex}
          >
            <button className={pageStyles.redButton}
              aria-label={getKnowMoreAriaLabel(knowMore)}
              onClick={onclick} tabIndex="0">
              <p className={pageStyles.labelButton}>
                {knowMore}
              </p>
            </button>
          </div>
        )}
      </div>
    </ActionElement>
  );
};

export default MarketingButton;
